export const RECOMMENDED_PRINT_POSITION_FLOW_ACTIVE = true;
export const EMBROIDERY_CONVERTER_ACTIVE =
  process.env.VUE_APP_EMBROIDERY_CONVERTER_ACTIVE === 'true';
